import { render, staticRenderFns } from "./VideoPlayButton.vue?vue&type=template&id=15bf95e4"
import script from "./VideoPlayButton.vue?vue&type=script&lang=js"
export * from "./VideoPlayButton.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayButton.vue?vue&type=style&index=0&id=15bf95e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports